/* eslint-disable */
import React from "react";
import myGif from "../../config/Resources/gif/gif.gif";

const CustomLoader: React.FC = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-opacity-50 bg-black">
      <div className=" flex flex-col items-center justify-center mx-auto border w-36.5 h-36.5 flex-shrink-0 rounded-lg bg-white">
        <img src={myGif} alt="My GIF" className="w-27.5 h-15 overflow-hidden" />

        <p className="w-19 h-5.5 text-black font-Lato text-lg font-bold leading-normal">
          Loading...
        </p>
      </div>
    </div>
  );
};

export default CustomLoader;
